export default __webpack_public_path__ + "static/logo_alone-3dea7a0618938f2485ede1de6b67b6b8.png";